module.exports = __webpack_public_path__ + "static/media/IMG_0560-modified.05c43964.png";